import BRZCase from "../Components/References/BRZCase";
import Footer from "../Components/Footer";

const BRZ = () => {
    return (
      <div>
        <BRZCase />
        <Footer />
      </div>
    );
  };
  
  export default BRZ;